import { useEffect } from "react";
import useComponentsStore from "./stores/ComponentsStore";
import components from "./settings/components";
import AppRoutes from "./routes";

function App() {
  const setComponents = useComponentsStore((state) => state.setComponents);

  useEffect(() => {
    setComponents({
      ...components,
    });
  }, []);

  return <AppRoutes />;
}

export default App;
